import {Set, Map} from 'immutable';
import {
  SET_ORGANIZATION_POIS,
} from '../actions';

const organizationFences = (state = Map({organizationPoiMap: Map(), paginatedPOIs: Map(Map())}), action) => {
  let newState = state;
  switch (action.type) {
    case SET_ORGANIZATION_POIS:
      newState = newState.setIn(['organizationPoiMap', action.payload.organizationId], action.payload.pois);
      newState = newState.setIn(['selectedFences'], Set());
      newState = newState.setIn(['paginatedPOIs', action.payload.organizationId, action.payload.page], action.payload.pois);
      return newState;
    default:
      return newState;
  }
}

export default organizationFences


// WEBPACK FOOTER //
// ./src/organizations/reducers/organizationPois.js